import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams,useNavigate } from 'react-router-dom';
import { visualizerActions, uiActions } from "../../store";

import ProductList from '../ProductList/ProductList';
import ProgressBar from '../ProgressBar/ProgressBar';
import StepsController from '../StepsController/StepsController';
import AppliedProducts from '../AppliedProducts/AppliedProducts';
import ExteriorPaint from "../ExteriorPaint/ExteriorPaint";
import ExteriorUpgrades from "../ExteriorUpgrades/ExteriorUpgrades";
import ExteriorTrimUpgrades from "../ExteriorTrimUpgrades/ExteriorTrimUpgrades";

import styles from './ProductMenu.module.css';
import { CabinetsStep,OptionalCabinetsStep, KitchenPlumbingStep, KitchenCabinetHardwareStep,BathroomCabinetHardwareStep,KitchenBacksplashStep,BaseboardStep,CabinetCrownMoldingStep } from "../Steps/Steps";


export default function ProductMenu() {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const activeStep = useSelector((state) => state.visualizer.activeStep);
    const activeFloorPlan = useSelector((state) => state.visualizer.activeFloorPlanData);
    const activeFloorPlanSteps = useSelector((state) => state.visualizer.activeFloorPlanSteps);
    const specifier = useSelector((state) => state.visualizer.specifier);
    const activePackage = useSelector((state) => state.visualizer.activePackage);

    const [appliedProductsView, setAppliedProductsView] = useState(false)


    // Do not render anything if active step is not selected
    if (activeStep === null || activeStep === undefined){
        navigate(`/floorplans`);
        return;
    }
    
    // Calculate progress by checking selections for each step 
    var completedSteps = activeFloorPlanSteps.filter(step => step.selection !== -1);
    // activeFloorPlanSteps.forEach((obj, key) => {
    //     if(obj.selection == -1)
    //         console.log('missing selection for:',obj)
    // });
    var progress = parseInt((completedSteps.length / activeFloorPlanSteps.length) * 100);


    
    
    // toggle applied products view
    const toggleAppliedProductsView = () => {
        setAppliedProductsView(appProdView => {
            return !appProdView;
        })
    }


    const HandleKitchenLightingSelect = (product) => {
        dispatch(visualizerActions.setSelection(product));

        document.getElementById('chamViz').applyByFilter(product.id, "", function (newSel, currentSelectedSurface) {

            if (activeStep.surfaceName === this.name) {
                dispatch(uiActions.setVizLoading(true));
                return  newSel == 5413607 ? -1 : newSel;
            }

        },true)
    }

    // Handle product selection event for each surface based on active step
    const handleProductSelect = (product) => {
        dispatch(visualizerActions.setSelection(product));

        document.getElementById('chamViz').applyByFilter(product.id, "", function (newSel, currentSelectedSurface) {

            if (activeStep.surfaceName === this.name) {
                dispatch(uiActions.setVizLoading(true));
                return newSel
            }

        },true)
    }

    const HandleDoorSelect = (product) => {
        dispatch(visualizerActions.setSelection(product));

        let doorColor = activePackage? activePackage.frontDoorChamID : 5432257;
        let door = `${product.id}(${doorColor})`;
        let sidelight = `${product.descriptor}(${doorColor})`;
    
        document.getElementById('chamViz').applyByFilter(door, "", function (newSel, currentSelectedSurface) {
            if(this.type === "DOOR") return door;
            if(this.type === "SIDELIGHTS") return sidelight;
            dispatch(uiActions.setVizLoading(true));
        },true)
    }

    const HandleBathroomCounterSelect = (product) => {
        dispatch(visualizerActions.setSelection(product));

        document.getElementById('chamViz').applyByFilter(product.id, "", function (newSel, currentSelectedSurface) {
            if(this.type === "COUNTER") {
                dispatch(uiActions.setVizLoading(true));
                return newSel;
            }
        },true)
    }

    const handleSendToSeagateModalButtonClick = function () {
        dispatch(uiActions.setSendToSeagateModalActive(true));
    }

    const HandleKitchenCounterSelect = (product) => {
        dispatch(visualizerActions.setSelection(product));

        document.getElementById('chamViz').applyByFilter(product.id, "", function (newSel, currentSelectedSurface) {
            if(this.name === "Counter" || this.name === "Backsplash 4in") {
                dispatch(uiActions.setVizLoading(true));
                return newSel;
            }
        },true)
        
    }

    const HandleBathroomFaucetSelection = (product) => {
        dispatch(visualizerActions.setSelection(product));
        
        let style = product.id;
        let faucetColor = product.warranty;
        let showerFrameColor = product.efficiency;

        console.log(product)

        document.getElementById('chamViz').applyByFilter(product.id, "", function (newSel, currentSelectedSurface) {
            if(this.name === "Faucet" || this.name === "Shower Head"){
                return `${style}(${faucetColor})`
            }
            if(this.name === "Shower Frame") return showerFrameColor;
            dispatch(uiActions.setVizLoading(true));
        },true)

    
    }

    //only called if spec contains Worthington_II_Bath
    const HandleBathroomShowerWallSelection = (product) => {
        dispatch(visualizerActions.setSelection(product));
            document.getElementById('chamViz').applyByFilter("", "", function (newSel, currentSelectedSurface) {
                if (['Shower Wall', 'Tub Surround', 'Shower Ledge', ''].includes(this.name)){
                    dispatch(uiActions.setVizLoading(true));
                    return product.id
                }
                    
        },true)
    }

    // Product list content
    // Default product list for the steps with a single series and simple click to select product setup
    let productListContent = <ProductList seriesId={activeStep.series} thumbSize="250" selectedProductId={activeStep.selection.id} filters={activeStep.filter} handleSelect={handleProductSelect} />;
    

    //Exterior Lights
    if(activeStep.id === 3){
        productListContent = <ProductList seriesId={activeStep.series} addNoneOption={true} thumbSize="250" selectedProductId={activeStep.selection.id} filters={activeStep.filter} handleSelect={handleProductSelect} />
    }

    //USE ExteriorPaint component
    if(activeStep.id === 2){
        productListContent = <ExteriorUpgrades/>
    }

    //Door step product list content
    if(activeStep.id === 5){
        productListContent = <ProductList seriesId={activeStep.series} thumbSize="250" selectedProductId={activeStep.selection.id} filters={activeStep.filter} handleSelect={HandleDoorSelect} />
    }
    // Cabinets step product list content
    if(activeStep.id === 7){
        productListContent = <CabinetsStep />
    }
    // Kitchen Cabinets hardware step product list content
    if(activeStep.id === 8 ){
        productListContent = <KitchenCabinetHardwareStep />
    }
    
    // Kitchen counter
    if(activeStep.id === 9){
        productListContent = <ProductList seriesId={activeStep.series} thumbSize="250" selectedProductId={activeStep.selection.id} filters={activeStep.filter} handleSelect={HandleKitchenCounterSelect} />
    }
    // Kitchen Plumbing Step product list content
    if(activeStep.id === 10){
        productListContent = <KitchenPlumbingStep />
    }
    //kitchen Backsplash
    if(activeStep.id === 11){
        productListContent = <KitchenBacksplashStep/>
    }
    // kitchen lighting
    if(activeStep.id === 14){
        productListContent = <ProductList seriesId={activeStep.series} thumbSize="250" selectedProductId={activeStep.selection == -1 ? 5413607 : activeStep.selection.id } filters={activeStep.filter} handleSelect={HandleKitchenLightingSelect} />
    }

     // Bathroom cabinets
     if(activeStep.id === 16){
        productListContent = <CabinetsStep />
    }

    // Bathroom Cabinets hardware step product list content
    if(activeStep.id === 17 ){
        productListContent = <BathroomCabinetHardwareStep />
    }

    // Bathroom counter product list
    if(activeStep.id === 18){
        productListContent = <ProductList seriesId={activeStep.series} thumbSize="250" selectedProductId={activeStep.selection.id} doesNotVizualize={activeFloorPlan.name=='Misty'} filters={activeStep.filter} handleSelect={HandleBathroomCounterSelect} />
    }
    // Bathroom faucet
    if(activeStep.id === 19){
        productListContent = <ProductList seriesId={activeStep.series} thumbSize="250" selectedProductId={activeStep.selection.id} filters={activeStep.filter} handleSelect={HandleBathroomFaucetSelection} />
    }

    // Bathroom shower walls
    if(activeStep.id === 22){
        productListContent = <ProductList seriesId={activeStep.series} thumbSize="250" selectedProductId={activeStep.selection.id} filters={activeStep.filter} handleSelect={specifier.indexOf('Worthington_II_Bath') != -1 ? HandleBathroomShowerWallSelection : handleProductSelect} />
    }

     // Bathroom vanity lights
     if(activeStep.id === 24){
        productListContent = <ProductList seriesId={activeStep.series} thumbSize="250" selectedProductId={activeStep.selection.id} doesNotVizualize={specifier.indexOf('Misty_Bath') != -1} filters={activeStep.filter} handleSelect={handleProductSelect} />
    }


    // Baseboard step
    if(activeStep.id === 25){
        productListContent = <BaseboardStep/>
    }

    // Cabinet Crown
    if(activeStep.id === 26){
        productListContent = <CabinetCrownMoldingStep/>
    }

    // Window Frames/Mullions
    if(activeStep.id === 28){
        productListContent = <ExteriorTrimUpgrades/>
    }

    // 
    if(activeStep.id === 29 || activeStep.id === 30){
        productListContent = <ProductList seriesId={activeStep.series} doesNotVizualize={true} thumbSize="250" selectedProductId={activeStep.selection.id} filters={activeStep.filter} handleSelect={handleProductSelect} />
    }

    // cabinets step
    if(activeStep.id === 31){
        productListContent = <OptionalCabinetsStep />
    }
    
    //USE ExteriorPaint component
    if(activeStep.step.toLowerCase() == 'exterior colors'){
        productListContent = <ExteriorPaint/>
    }

    

    
    // 3D Products steps
    // if(activeStep.id == 20){
    //     let sceneName = activeScene.replaceAll("\\","\\\\");
    //     let filter = `prod['descriptor'] === '${sceneName}'`;
    //     productListContent = <ProductList seriesId={activeStep.series} thumbSize="250" selectedProductId={activeStep.selection.id} filters={filter} handleSelect={handleProductSelect} />;
    // }


    return (
        <section className={styles.productMenu}>
            {/* Product selection section  */}
            {!appliedProductsView &&
                <>
                    <ProgressBar progress={progress} />
                    <StepsController />
                    {productListContent}
                </>}

            {/* Applied products section  */}
            {appliedProductsView &&
                <>
                    <AppliedProducts />
                    <button onClick={handleSendToSeagateModalButtonClick} type="button" aria-label="Website">Send to SeaGate Homes</button>
                </>}

            <button onClick={toggleAppliedProductsView}>
                {appliedProductsView && "Back to Menu"}
                {!appliedProductsView && "View Applied Products"}
            </button>

        </section>
    );
}
